<template>
  <div id="app">
    <svg-sprite />
    <Loading v-show="$store.state.loading === true"/>
    <MenuBar v-show="$store.state.loading === false"/>
    <router-view :key="$route.fullPath" v-show="$store.state.loading === false"/>
    <Footer v-show="$store.state.loading === false"/>
  </div>
</template>

<script>
import MenuBar from "./components/menu/MenuBar.vue";
import Footer from "./components/Footer.vue";
import Loading from "./components/Loading.vue";
export default {
  name: "App",
  components: {
    MenuBar,
    Footer,
    Loading,
  },
  metaInfo() {
    return {
      meta: [
        {
          vmid: "robots",
          name: "robots",
          content: process.env.NODE_ENV === "development" ? "noindex,nofollow" : "index,follow"
        },
        { vmid: "og:image", property: "og:image", content: "https://kingsleague.ca/og-image.png" },
        { vmid: "og:site_name", property: "og:site_name", content: "The Kings League" },
        { vmid: "og:locale", property: "og:locale", content: "en_CA" },
        { vmid: "og:locale:alternate", property: "og:locale:alternate", content: "fr_CA" },
        { vmid: "twitter:card", name: "twitter:card", content: "summary_large_image" },
        { vmid: "twitter:image", name: "twitter:image", content: "https://kingsleague.ca/og-image.png" }
      ],
      link: [
        { rel: "alternate", hreflang: "en", href: "https://kingsleague.ca" + this.$route.path },
        { rel: "alternate", hreflang: "fr", href: "https://kingsleague.ca" + this.$route.path },
        { rel: "alternate", hreflang: "es", href: "https://kingsleague.ca" + this.$route.path },
        { rel: "alternate", hreflang: "x-default", href: "https://kingsleague.ca" + this.$route.path }
      ],
      script: [{
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "SportsOrganization",
          "name": "The Kings League",
          "alternateName": "TKL",
          "url": "https://kingsleague.ca",
          "logo": "https://kingsleague.ca/og-image.png",
          "description": "Montreal and Laval's best adult amateur indoor and outdoor soccer league. Offering organized leagues and tournaments with qualified referees.",
          "email": "info@kingsleague.ca",
          "telephone": "+18778557855",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "2385 Boulevard Thimens",
            "addressLocality": "Saint-Laurent",
            "addressRegion": "QC",
            "postalCode": "H4R 1T4",
            "addressCountry": "CA"
          },
          "areaServed": [
            { "@type": "City", "name": "Montreal" },
            { "@type": "City", "name": "Laval" }
          ],
          "sport": "Soccer",
          "sameAs": [
            "https://www.facebook.com/TKLeague/",
            "https://www.instagram.com/tkleague/",
            "https://www.youtube.com/@TheKingsLeague"
          ]
        }
      }]
    };
  },
  beforeCreate(){
    this.$store.dispatch('init');
    this.$i18n.locale = localStorage.getItem('lang') || "en";
  },
};
</script>
<style lang="scss">
@import "@/main.scss";
</style>

